import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import StoreTopbar from "./StoreTopbar";
import HubFooter from "./HubFooter";
import LaunchNotify from "./LaunchNotify";

const PLANS = { single: "Single bot", five: "Five bots", all: "Everything" };

export default function NotifyPage() {
  const [params] = useSearchParams();
  const plan = PLANS[params.get("plan")];
  return (
    <div data-testid="notify-page" className="min-h-screen bg-[#050914] text-[#F1F5F9]">
      <StoreTopbar subtitle="Launch list" />
      <main className="max-w-3xl mx-auto px-6 py-14">
        {plan && (
          <div data-testid="notify-plan-note" className="mb-6 text-sm text-[#CBD5E1]">
            The <b className="text-[#FBBF24]">{plan}</b> plan will be available when the store opens.
          </div>
        )}
        <LaunchNotify testid="notify-form" />
        <div className="mt-8 text-sm text-[#94A3B8]">
          While you wait: <Link to="/mt5" className="text-[#38BDF8] underline">browse the bots</Link> or follow my{" "}
          <Link to="/track-record" className="text-[#38BDF8] underline">demo track record</Link>.
        </div>
      </main>
      <HubFooter />
    </div>
  );
}
